import { logger } from '../../../utils/logger';
import { cxoneSdkState } from '../state';
import type { TransferAgent } from '../types';
import { acdApiGet, extractArrayFromResponse } from './acd-api.util';

function mapAgentItem(item: unknown): TransferAgent {
  const agent = item as {
    agentId?: string | number;
    AgentId?: string | number;
    userName?: string;
    UserName?: string;
    firstName?: string;
    FirstName?: string;
    lastName?: string;
    LastName?: string;
    state?: string;
    State?: string;
    currentState?: string;
    CurrentState?: string;
    teamName?: string;
    TeamName?: string;
  };

  const agentId = String(agent.agentId || agent.AgentId || '');
  const firstName = agent.firstName || agent.FirstName || '';
  const lastName = agent.lastName || agent.LastName || '';
  const agentName =
    `${firstName} ${lastName}`.trim() || agent.userName || agent.UserName || 'Unknown';
  const state = agent.state || agent.State || agent.currentState || agent.CurrentState || 'Unknown';

  return {
    agentId,
    agentName,
    firstName,
    lastName,
    state,
    teamName: agent.teamName || agent.TeamName || undefined,
    isAvailable: state.toLowerCase() === 'available',
  };
}

export async function getAgentsList(): Promise<TransferAgent[]> {
  logger.debug('[CXone SDK] Getting agents list...');

  try {
    const data = await acdApiGet('/InContactAPI/services/v23.0/agents', 'getAgentsList');
    if (!data) {
      return [];
    }

    const currentAgentId = cxoneSdkState.storedUserInfo?.icAgentId;
    const agents = extractArrayFromResponse(data, ['agents', 'Agents']);
    const mappedAgents = agents
      .map(mapAgentItem)
      .filter((agent) => agent.agentId !== currentAgentId);

    logger.debug('[CXone SDK] Mapped agents:', mappedAgents);
    return mappedAgents;
  } catch (error) {
    logger.error('[CXone SDK] getAgentsList failed:', error);
    return [];
  }
}
